<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="'Leave Page?'"
    :submit-button-text="'LEAVE'"
    :submit-modal="leavePage"
  >
    <p class="tsny_status-text">
      {{ modalText }}
    </p>
  </tsny-modal>
</template>

<script>
import TsnyModal from "./TsnyModal";
export default {
  name: "NavigationAlert",
  components: { TsnyModal },
  props: {
    modalText: {
      type: String,
      default:
        "Are you sure you want to leave the page? You have unsaved changes that will be lost if you do"
    },
    next: {
      type: Function,
      default: null
    }
  },
  data: () => ({
    modalId: "navigationAlert"
  }),
  methods: {
    leavePage() {
      this.next();
    }
  }
};
</script>

<style scoped></style>
